module.exports = __webpack_public_path__ + "img/自动支付采购费.ee647c77.svg";